import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchGatewaysRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  @observable
  externalGatewayIdent?: string;

  @observable
  includeDeleted?: boolean;
}
